import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center overflow-hidden bg-foreground-950">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20spotlight%20on%20dark%20stage%2C%20red%20and%20orange%20light%20beams%20breaking%20through%20darkness%2C%20mysterious%20atmospheric%20entertainment%20venue%2C%20cinematic%20abstract%20background%2C%20high%20contrast%20warm%20tones%2C%20premium%20news%20portal%20aesthetic&width=1920&height=1080&seq=hero-bg&orientation=landscape"
          alt="53吃瓜网站背景"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-20">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl">
            {/* Label */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 backdrop-blur-sm mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
              <span className="text-accent-400 text-xs font-medium tracking-wider uppercase">
                全网独家追踪
              </span>
            </div>

            {/* Main Title */}
            <h1 className="font-heading font-black text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.1] mb-6">
              53吃瓜
              <br />
              <span className="text-primary-400">圈内猛料</span>
              <br />
              首发平台
            </h1>

            {/* Subtitle */}
            <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-xl mb-8">
              持续追踪全网吃瓜52最新动态，覆盖53吃瓜圈内部讨论与本周必看娱乐爆料合集。真实爆料，全网追踪。
            </p>

            {/* CTA Button */}
            <Link
              to="/category/star-gossip"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium border border-white/20 hover:bg-white/25 transition-all"
            >
              开始吃瓜
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom brand text */}
      <div className="absolute bottom-8 left-0 right-0 z-10 px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <p className="text-white/10 font-heading font-black text-5xl md:text-7xl lg:text-8xl tracking-tight">
            53吃瓜网
          </p>
        </div>
      </div>
    </section>
  );
}